<template>
  <a-spin :spinning="isLoading">
    <div class="statistics-card">
      <div class="text">
        <div class="title">
          {{ title }}
        </div>
        <div class="body">
          <slot />
        </div>
      </div>
      <a-progress
        type="circle"
        :percent="percent"
        :stroke-color="{
          '0%': from,
          '100%': to,
        }"
      >
        <template #format>
          <div class="percent-value">
            {{ percent }}%
          </div>
          <div class="percent-title">
            {{ percentTitle }}
          </div>
        </template>
      </a-progress>
    </div>
  </a-spin>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'StatisticsCard',
  components: {},
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    percentTitle: {
      type: String,
      required: true
    },
    percent: {
      type: Number,
      required: true
    },
    from: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    }
  },
  setup () {
  }
})
</script>

<style lang="less" scoped>
.statistics-card {
  padding: 12px 16px;
  background-color: #F7F8F9;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}

.percent-value {
  font-size: 18px;
  line-height: 28px;
}

.percent-title {
  color: rgba(0, 0, 0, .5);
  font-size: 12px;
}
</style>
